import { PhysXActor } from "../physx/PhysXActor";
import { PhysXObject } from "../physx/PhysXObject";
import { PhysXScene } from "../physx/PhysXScene";
import { RTPhysXSensor } from "./sensors/RTPhysXSensor";
import { SimLidar } from "./sensors/SimLidar";

export class RobotPhysXActor extends PhysXActor {
  public sensors: RTPhysXSensor[] = [];
  public robotId: string;

  constructor(object: PhysXObject, scene: PhysXScene) {
    super(object, scene);
    this.robotId = object.props.robotId;
    this.sensors.push(new SimLidar(this, this.obj,
      {
        frequency: 4.0,
        arc: { min: -70, max: 70 },
        rays: 140,
        range: { min: 0.1, max: 8.0 },
        verticalScan: {
          stepSize: 2,
          ringsDown: 15,
          ringsUp: 10
        }
      },
      {
        position: [0.60, 0, 0.5],
      },
    ));

  }


  render(delta: number): void {
    // Implementation for rendering the Robotech actor
    // console.log("RTActor render called with delta:", delta);
    this.sensors.forEach(sensor => sensor.render(delta));
  }
}